import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useWayToPayStore } from "../../hooks/useWayToPayStore";
import { WayToPayByCompanyModal } from "./components/WayToPayByCompanyModal";
import { RoutesMap } from "../../types";
import { useImportStore } from "../../hooks/useImportStore";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'wayToPay', label: 'Nombre', align: 'center' },
    { type: 'text', field: 'status', label: 'Estado', align: 'center', format: (row) => row.status == 1 ? 'Activado' : 'Desactivado' },
    { type: 'detail', field: 'detail', label: 'Acciones', align: 'center' },
];

const breadcrumbs = [
    { id: 1, label: 'Maestros' },
    { id: 2, label: 'Formas de pago', pathname: RoutesMap.WAY_TO_PAY }
]

export const WayToPayView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionWayToPay, getWayToPay, getWayToPayByCompany } = useWayToPayStore();
    const { status: statusImport, downloadTemplate } = useImportStore()

    const [loading, setLoading] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getWayToPayByCompanyApi()
    }, [])

    const getWayToPayByCompanyApi = async (search = '') => {
        try {
            setLoading(true);
            const response = await getWayToPayByCompany(search);
            const newData: any = [];
            response && (response).length > 0 && (response).map((item) => {
                newData.push({
                    ...item,
                    idcuotas: JSON.parse(item.idcuotas),
                    idtools: JSON.parse(item.idtools),
                })
            })
            setPaymentMethods(newData || []);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionWayToPay('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected: any) => {
        setActionWayToPay('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected: any) => {
        setActionWayToPay('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected: any) => {
        setActionWayToPay('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onSwitch = () => {

    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getWayToPayByCompanyApi(term) }, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    const downloadTemplateApi = async () => {
        const url: string | false = await downloadTemplate(3) //3: formas de pago
        if (url === false) return

        const win: any = window.open(`${process.env.REACT_APP_ROOT_URL}` + url)
        win.focus()
    }

    const onImport = async (event) => {
        const file = event.target.files[0]
        if (file) {

        }
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable
                    breadcrumbs={breadcrumbs}
                    title={'Formas de pago'}
                    columns={columns}
                    loading={loading}
                    rows={paymentMethods || []}
                    onRowClick={() => { }}
                    hasOptions
                    onEdit={onEdit}
                    onSwitch={onSwitch}
                    onSearch={onSearch}
                    dense
                    onImport={onImport}
                    template={downloadTemplateApi}
                />
            </Grid>
            {
                showModal && (
                    <WayToPayByCompanyModal
                        open={showModal}
                        closeModal={() => { setShowModal(false) }}
                        waytopaySelected={rowSelected}
                        listWaytopay={getWayToPayByCompanyApi}
                        clearState={clearState}
                    />
                )
            }
            {/* {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            } */}
        </>
    )
}